import { render } from "./MyRewards.vue?vue&type=template&id=3d950490&scoped=true"
import script from "./MyRewards.vue?vue&type=script&lang=js"
export * from "./MyRewards.vue?vue&type=script&lang=js"

import "./MyRewards.vue?vue&type=style&index=0&id=3d950490&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d950490"]])

export default __exports__